import React, { useState } from 'react';
import '../styles/GeneralStyles.css';
import iconRadio1 from '../assets/ring-vector-1.svg'
import iconArrowLeft from '../assets/arrow-left.svg'
import iconArrowRight from '../assets/arrow-right.svg'
import img025Quitales from '../assets/quilates/OptArtboard-1_1-100.webp'
import img050Quitales from '../assets/quilates/OptArtboard-1_2-100.webp'
import img075Quitales from '../assets/quilates/OptArtboard-1_3-100.webp'
import img100Quitales from '../assets/quilates/OptArtboard-1_4-100.webp'
import potadaQuilates from '../assets/portadas/Portada-02-Quilates.webp'

const Step1 = ({ nextStep, prevStep, handleInputChange, formData, isSubmitting }) => {
  const [selectedOption, setSelectedOption] = useState(formData?.carats || null);

  const options = [
    {
      id: 1,
      icon: iconRadio1,
      text: "0.25",
      value: 6450,
      title: "0.25 Quilates",
      description: "Delicado",
      image: img025Quitales,
    },
    {
      id: 2,
      icon: iconRadio1,
      text: "0.50",
      value: 19565,
      title: "0.50 Quilates",
      description: "Encantador",
      image: img050Quitales
    },
    {
      id: 3,
      icon: iconRadio1,
      text: "0.75",
      value: 34400,
      title: "0.75 Quilates",
      description: "Clásico y elegante",
      image: img075Quitales
    },
    {
      id: 4,
      icon: iconRadio1,
      text: "1.00",
      value: 88150,
      title: "1.00 Quilate",
      description: "Impactante y radiante",
      image: img100Quitales
    }
  ];

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    // Ahora pasamos el id del option seleccionado junto con la opción completa
    handleInputChange('carats', {
      ...option,
      selectedId: option.id // Añadimos el id seleccionado para usar en los siguientes pasos
    });
  };
//empieza el componente
  return (
    <div className='container-large'>
      <div className='wrapp-principal-2-columns'>
        <div className="options-column">
          <div className='text-n-options'>
            <h2 className='heading-style-h3 text-align-center'>Selecciona los Quilates del Diamante</h2>
            <p className='text-size-medium text-color-grey'>Un quilate equivale a 200 miligramos, o 0,2 gramos. Esta característica determina el tamaño del diamante. Es la de mayor impacto en el precio final.</p>
            <div className='container-radio-options'>
            <div className='wrapp-radio-options'>
              <div className="radio-options">
              {options.map((option) => (
                <label key={option.id} className="radio-label">
                  <input
                    type="radio"
                    name="carats"
                    checked={selectedOption?.id === option.id}
                    onChange={() => handleOptionSelect(option)}
                  />
                  <img src={option.icon} className="radio-icon" alt="ring icon" />
                  <span className="radio-text">{option.text}</span>
                </label>
              ))}
              </div>
            </div>
            </div>
          </div>
          
          <div className="wrapp-btns">
            <button className="button-prev" onClick={prevStep}>
            <img src={iconArrowLeft} alt="arrow left" />
              Volver
              
            </button>
            <button 
              className="button" 
              onClick={nextStep}
              disabled={!selectedOption}
            >
              Siguiente
              <img src={iconArrowRight} alt="arrow right" />
            </button>
          </div>
        </div>
        
        <div className="preview-column">
          {selectedOption ? (
            <>
              <div className='imgOptionSelected'>
                <img 
                  src={selectedOption.image} 
                  alt={selectedOption.text}
                  className="ring-preview-image"
                />
              </div>
              <div className='textOptionSelected'>
                <h3 className="text-align-left">{selectedOption.title}</h3>
                <p className="text-style-medium text-align-left">
                  {selectedOption.description}
                </p>
              </div>
            </>
          ) : (
            <div className="no-selection-message">
              <img src={potadaQuilates} className='imgPreviewNoText' alt="Preview anillo" />
              <div className='wrappNoSelectText'>
                <p className='heading-style-h4 text-weight-bold text-color-white'>Quilates</p>
                <p className='text-size-large text-color-white'>Por favor selecciona los quilates</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Step1;
